// Environment Configuration
// Change this to switch between environments
const ENVIRONMENT = 'production'; // 'local' or 'production'

const API_URLS = {
  local: 'http://localhost:8000',
  production: 'https://api.mustoresystem.cloudlab.com.np'
  //  production: 'http://localhost:8000'
};

const API_BASE_URL = API_URLS[ENVIRONMENT];

export default API_BASE_URL;
export { ENVIRONMENT };
